import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const ShippingPage = lazy(() => import('@/pages/shipping'));

export const Route = createFileRoute('/shipping')({
  component: function ShippingRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <ShippingPage />
      </Suspense>
    );
  },
});
